import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Ecology from '../views/staking_mine.vue'
import Contribute from '../views/Contribute.vue'
import Develop from '../views/Develop.vue'
import Server from '../views/point.vue'
import News from '../views/News.vue'
import Detail from '../views/Detail.vue' // 新增：注册详情页组件

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/ecology',
    name: 'Ecology',
    component: Ecology
  },
  {
    path: '/staking_mine',
    name: 'StakingMine',
    component: Ecology
  },
  {
    path: '/contribute',
    name: 'Contribute',
    component: Contribute
  },
  {
    path: '/develop',
    name: 'Develop',
    component: Develop
  },
  {
    path: '/server',
    name: 'Server',
    component: Server
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '/detail',        // 新增：详情页路由
    name: 'Detail',
    component: Detail
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {

    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
